import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Typography, Layout, message } from 'antd';
import { apiFetch } from "../utils/api";
import { useSession } from '../context/SessionContext';

const { Title } = Typography;
const { Content } = Layout;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useSession(); // ahora usamos el hook directamente

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const formData = new URLSearchParams();
      formData.append('username', values.username);
      formData.append('password', values.password);

      const res = await apiFetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData,
        // credentials: 'include' // asegura que se envíe/reciba la cookie de sesión
      });
      // if (!res) return;

      if (res && res.ok) {
        const data = await res.json();
        login(data.username, data.roles); // guarda usuario y roles globalmente
        message.success('Login successful!');
        navigate('/map'); // redirige a mapa (o dashboard)
      } else {
        message.error('Invalid username or password');
      }
    } catch (err) {
      console.error(err);
      message.error('Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Form
          name="login"
          onFinish={handleSubmit}
          layout="vertical"
          style={{ width: 300 }}
        >
          <Title level={3}>Login</Title>
          <Form.Item name="username" label="Username" rules={[{ required: true }]}>
            <Input autoFocus />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Content>
    </Layout>
  );
};

export default Login;
